import { render } from "./ProjectInsights.vue?vue&type=template&id=6a935e34&scoped=true"
import script from "./ProjectInsights.vue?vue&type=script&lang=js"
export * from "./ProjectInsights.vue?vue&type=script&lang=js"

import "./ProjectInsights.vue?vue&type=style&index=0&id=6a935e34&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a935e34"]])

export default __exports__